<template>
  <v-container fluid class="login-page pa-4 pa-md-8">
    <v-row class="login-shell" no-gutters>
      <v-col cols="12" md="7" lg="8" class="login-col-left pa-4 pa-md-8">
        <div class="login-left-overlay">
          <div class="kicker mb-4">{{ $t('mensajes.login.agencias') }}</div>
          <h1 class="login-title mb-3" style="text-align: center;">{{ $t('mensajes.login.trabaja_con_nosotros') }}</h1>
          <p class="login-subtitle mb-8">
            {{ $t('mensajes.login.descripcion_registro') }}
          </p>

          <v-row v-if="!mostrarFormularioRegistro" class="mb-8 mt-12" justify="center">
            <v-col cols="12" sm="8" md="7" lg="6">
              <v-btn
                block
                large
                rounded
                elevation="0"
                class="action-btn"
                :color="colorAccent1"
                @click="_mostrarFormularioRegistro"
              >
                {{ $t('mensajes.login.contactar') }}
              </v-btn>
            </v-col>
          </v-row>

          <v-card v-if="mostrarFormularioRegistro" class="signup-card" style="background-color: transparent;" flat>
            <v-card-text class="pa-6">
              <v-text-field
                v-model="solicitudAgencia"
                :label="$t('mensajes.login.agencia_requerida')"
                type="text"
                outlined
                dense
                background-color="white"
                autocomplete="off"
              />

              <v-text-field
                v-model="solicitudResponsable"
                :label="$t('mensajes.login.responsable_requerido')"
                type="text"
                outlined
                dense
                background-color="white"
                autocomplete="off"
              />

              <v-text-field
                v-model="solicitudCorreo"
                :label="$t('mensajes.login.email_requerido')"
                type="email"
                outlined
                dense
                background-color="white"
                autocomplete="off"
              />

              <v-text-field
                v-model="solicitudTelefono"
                :label="$t('mensajes.login.telefono_requerido')"
                type="text"
                outlined
                dense
                background-color="white"
                autocomplete="off"
              />

              <v-textarea
                v-model="solicitudMensaje"
                :label="$t('mensajes.login.mensaje_opcional')"
                outlined
                dense
                background-color="white"
                autocomplete="off"
                rows="3"
                @keydown.enter="_solicitarRegistroAgencia"
              />

              <v-alert v-if="solicitudError" type="error" dense outlined class="mt-2 mb-3">
                {{ solicitudError }}
              </v-alert>

              <v-alert v-if="solicitudEnviada" type="success" dense outlined class="mt-2 mb-3">
                {{ $t('mensajes.login.solicitud_enviada') }}
              </v-alert>

              <v-btn
                block
                large
                rounded
                elevation="0"
                class="action-btn mb-12"
                :color="colorAccent1"
                :disabled="!puedeEnviarSolicitud || enviandoSolicitudRegistro"
                @click="_solicitarRegistroAgencia"
              >
                <span v-if="enviandoSolicitudRegistro">{{ $t('mensajes.login.enviando') }}</span>
                <span v-else>{{ $t('mensajes.login.enviar_solicitud') }}</span>
              </v-btn>

              
            </v-card-text>
          </v-card>
        </div>
      </v-col>

      <v-col cols="12" md="5" lg="4" class="login-col-right pa-4 pa-md-8">
        <v-card class="login-card mx-auto" style="background-color: transparent;" max-width="400" flat>
          <v-card-text class="pa-8">
            <v-row class="mb-4">
              <v-col>
                <v-img src="../assets/logo3.png" contain max-height="100" min-height="100" />
              </v-col>
            </v-row>

            <h1 class="access-title mb-4 text-center">{{ $t('mensajes.login.agencia_registrada') }}</h1>

            <h2 class="access-title mb-10 text-center">{{ $t('mensajes.login.accede_con_tus_datos') }}</h2>


            <v-text-field
              v-model="name"
              :label="$t('mensajes.login.nombre')"
              name="name"
              type="text"
              outlined
              dense
              background-color="white"
              autocomplete="off"
            />

            <v-text-field
              id="password"
              v-model="password"
              :label="$t('mensajes.login.contrasena')"
              :name="$t('mensajes.login.contrasena')"
              outlined
              dense
              type="password"
              background-color="white"
              @keydown.enter="_login"
            />

            <v-alert v-if="error && errorMessage" type="error" dense outlined class="mt-2 mb-3">
              {{ errorMessage }}
            </v-alert>

            <v-btn
              block
              large
              rounded
              elevation="0"
              class="action-btn"
              :color="colorAccent1"
              @click="_login"
            >
              <span v-if="loading">{{ $t('mensajes.login.accediendo') }}</span>
              <span v-else>{{ $t('mensajes.login.acceder') }}</span>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { perfilAgenciaCompleto } from "../config/perfilAgencia";
export default {
  data: () => ({
    show: false,
    name: "",
    password: "",
    solicitudAgencia: "",
    solicitudResponsable: "",
    solicitudCorreo: "",
    solicitudTelefono: "",
    solicitudMensaje: "",
    mostrarFormularioRegistro: false,
    enviandoSolicitudRegistro: false,
    solicitudEnviada: false,
    solicitudError: "",
  }),

  computed: {
    ...mapState([
      "loading",
      "colorFondoDialog",
      "colorBarraFormulario",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    puedeEnviarSolicitud() {
      return [
        this.solicitudAgencia,
        this.solicitudResponsable,
        this.solicitudCorreo,
        this.solicitudTelefono,
      ].every((campo) => campo && campo.trim());
    },
  },

  mounted() {
    this.aplicarIdioma(this.$route.params.language);
   /* this.name = 'admin';
    this.password = 'abc1234';*/
    this._logout();
  },

  watch: {
    '$route.params.language'(language) {
      this.aplicarIdioma(language);
    },
  },

  methods: {
    ...mapActions("auth", ["login", "logOut"]),
    ...mapActions("reservas", ["solicitarRegistroAgencia"]),
    ...mapMutations(["setDrawer"]),

    perfilAgenciaCompleto(origen) {
      return perfilAgenciaCompleto(origen);
    },

    aplicarIdioma(language) {
      const idioma = String(language || 'es').toLowerCase();
      this.$i18n.locale = ['es', 'en', 'de'].includes(idioma) ? idioma : 'es';
    },

    async _login() {
      await this.login([this.name, this.password]);
      if (!this.error && this.user != null) {
        this.setDrawer(true);
        const agenciaId = this.user.origen && this.user.origen.identificador ? this.user.origen.identificador : 'web';
        const perfilCompleto = this.perfilAgenciaCompleto(this.user.origen);
        const query = perfilCompleto
          ? { tab: 'expedientes' }
          : { tab: 'perfil_agencia', aviso_perfil_incompleto: '1' };

        if (this.user.rol == 'AGENCIA' && agenciaId != '' ) {
          this.$router.push({
            name: 'central_reservas_ext',
            params: {
              agencia: agenciaId,
              language: this.$i18n.locale
            },
            query
          });
        } else {
          this.$router.push({
            name: 'central_reservas',
            params: {
              admin: 'adm',
              agencia: agenciaId,
              camino_id: 0,
              language: this.$i18n.locale.toUpperCase()
            },
            query
          });
        }
      }
    },

    async _logout() {
      await this.logOut([this.access_token]);
    },

    _emailValido(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || "").toLowerCase());
    },

    _mostrarFormularioRegistro() {
      this.mostrarFormularioRegistro = true;
      this.solicitudError = "";
      this.solicitudEnviada = false;
    },

    _ocultarFormularioRegistro() {
      this.mostrarFormularioRegistro = false;
      this.solicitudError = "";
    },

    async _solicitarRegistroAgencia() {
      this.solicitudError = "";
      this.solicitudEnviada = false;

      const agencia = this.solicitudAgencia ? this.solicitudAgencia.trim() : "";
      const responsable = this.solicitudResponsable ? this.solicitudResponsable.trim() : "";
      const correo = this.solicitudCorreo ? this.solicitudCorreo.trim() : "";
      const telefono = this.solicitudTelefono ? this.solicitudTelefono.trim() : "";
      const mensaje = this.solicitudMensaje ? this.solicitudMensaje.trim() : "";

      if (!agencia || !responsable || !correo || !telefono) {
        this.solicitudError = this.$t('mensajes.login.error_campos_obligatorios');
        return;
      }

      if (!this._emailValido(correo)) {
        this.solicitudError = this.$t('mensajes.login.error_email_invalido');
        return;
      }

      if (this.enviandoSolicitudRegistro) return;

      this.enviandoSolicitudRegistro = true;
      const response = await this.solicitarRegistroAgencia([agencia, responsable, correo, telefono, mensaje]);

      if (response) {
        this.solicitudEnviada = true;
        this.solicitudAgencia = "";
        this.solicitudResponsable = "";
        this.solicitudCorreo = "";
        this.solicitudTelefono = "";
        this.solicitudMensaje = "";
      } else {
        this.solicitudError = this.$t('mensajes.login.error_solicitud');
      }

      this.enviandoSolicitudRegistro = false;
    },
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(circle at 15% 20%, rgba(25, 25, 112, 0.2), transparent 40%),
    radial-gradient(circle at 85% 80%, rgba(255, 156, 0, 0.22), transparent 38%),
    #e8ebe6;
}

.login-shell {
  width: 100%;
  max-width: 1080px;
  min-height: 640px;
  margin: 0 auto;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 30px 60px rgba(24, 28, 44, 0.15);
}

.login-col-left {
  background-image:
    linear-gradient(140deg, rgba(23, 37, 84, 0.78), rgba(35, 89, 131, 0.7)),
    url("../assets/fondo-agencia.webp");
  background-size: cover;
  background-position: center;
}

.login-left-overlay {
  height: 100%;
  color: #ffffff;
}

.kicker {
  display: inline-block;
  padding: 6px 12px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 100px;
  font-size: 0.75rem;
  letter-spacing: 1px;
}

.login-title {
  font-size: clamp(1.9rem, 3vw, 2.8rem);
  line-height: 1.12;
}

.login-subtitle {
  max-width: 640px;
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.9);
}

.signup-card {
  width: 100%;
  max-width: 460px;
  margin: 0 auto;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.88);
  
}

.login-col-right {
  background: rgba(245, 246, 241, 0.96);
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-card {
  width: 100%;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 16px 30px rgba(18, 24, 40, 0.1);
}

.access-title {
  color: #191970;
  font-size: 1.35rem;
}

.access-description {
  color: #191970;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.4;
}

.action-btn {
  text-transform: none;
  letter-spacing: 0;
  font-weight: 700;
  color: #ffffff !important;
}

.action-btn.v-btn--disabled {
  opacity: 1 !important;
  color: rgba(255, 255, 255, 0.9) !important;
}

.action-btn.v-btn--disabled:not(.v-btn--text):not(.v-btn--outlined):not(.v-btn--icon) {
  background-color: rgba(255, 156, 0, 0.65) !important;
}

@media (max-width: 960px) {
  .login-shell {
    max-width: 100%;
    min-height: auto;
  }

  .login-col-left,
  .login-col-right {
    border-radius: 0;
  }

  .login-title {
    font-size: 1.7rem;
  }
}
</style>
